import React from 'react'

import { useLocation } from 'react-router-dom'

import { Col, Row } from '_zari/core'

import * as Sections from './sections'

const HomePage = () => {
  const location = useLocation()

  const show = React.useMemo(() => {
    return location.pathname === '/'
  }, [location.pathname])

  return (
    <>
      {show && (
        <Row>
          <Col md={6} />
          <Col md={6}>
            <Sections.LetrasPendientesSection />
          </Col>
        </Row>
      )}
    </>
  )
}

export default HomePage
